import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  quantity: yup.number().required()
})
